<!---===================== MODAL FOR UPDATE FIN =====================--->
<section (click)="VerifySweetAlert()" class="Modal-Global" id="ModalUpdateFIN">
  <div class="wrapper">
    <div class="Pro-popupFIN1 popup">
      <div class="Pro-insideFIN1 popup-inside">
        <div class="Pro-backgroundsFIN1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormFINUpdate" (submit)="ValidToogleFIN_Update()">
        <div class="Pro-contentFIN1 content">
          <button type="button" id="Btn-Close-Upd-Top" class="Btn-Close" (click)="ToggleModalUpdateFIN(false)"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Actualizar Proceso</h2>
          </div>

          <div class="Content-body">

            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre de Proceso
              </div>
              <div class="Container-input InputFile" id="IdInputFileUpdFIN">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivo</div><input #UpdFile (change)="AddDocument_Update($event)"
                    type="file" name="">
                </div>
                <div class="Name-File">
                  {{CutNameFile(this.FileAuxUpdFIN.FileName,20)}}
                </div>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Código del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-qrcode"></i><input id="IdinputCodeUpdFIN" type="text" formControlName="Code"
                  placeholder="Código…" [class.Is-Disabled]="NameFileFINUpdate.invalid"
                  [appFormFINDisabled]="NameFileFINUpdate.invalid">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Objetivo del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-message"></i><input id="IdinputPurpUpdFIN" type="text" formControlName="Purpose"
                  placeholder="Objetivo del Proceso (Purpose)…" [class.Is-Disabled]="NameFileFINUpdate.invalid"
                  [appFormFINDisabled]="NameFileFINUpdate.invalid">
              </div>
            </div>

            <div class="Content-grid-2" *ngFor="let reviewerSlot of VisibleReviewersUpdate">
              <div class="Text-icon">
                {{GetReviewerLabelUpdate(reviewerSlot)}}
              </div>
              <div class="Container-input Input-Autocomplete">
                <i class="fa-regular fa-user"></i>
                <ng-autocomplete class="ng-autocomplete" [data]="GetReviewerUsersUpdate(reviewerSlot)"
                  id="IdInputAuA{{reviewerSlot}}UpdFIN" [initialValue]="" [placeholder]="'Buscar ' + GetReviewerLabelUpdate(reviewerSlot)"
                  searchKeyword="Name" notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateReviewers"
                  [notFoundTemplate]="notFoundReviewers" [formControlName]="GetApproverControlNameUpdate(reviewerSlot)"
                  [appFormFINDisabled]="NameFileFINUpdate.invalid" [class.Is-Disabled]="NameFileFINUpdate.invalid"
                  [class.Is-Warning]="UserIsReplicated_Update(reviewerSlot - 1)">
                </ng-autocomplete>

                <ng-template #itemTemplateReviewers let-item>
                  <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundReviewers let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Anexos
              </div>
              <div class="Container-input InputFile" [class.Is-Disabled]="NameFileFINUpdate.invalid">
                <div class="IputFileleft" [class.Is-Disabled]="NameFileFINUpdate.invalid">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivos</div><input #UpdFileAnnexe type="file" name=""
                    (change)="Add_Document_Annexe_Upd($event)" [disabled]="NameFileFINUpdate.invalid">
                </div>
              </div>
            </div>

            <div class="Content-grid-2 Container-Annexes">
              <div class="Not-Annexes" [class.Is-Disabled-Img]="NameFileFINUpdate.invalid">
                <div class="Img-Not ">
                  <img src="./assets/Global/Ilustrations/Not-Annexes.png" alt="">
                </div>
              </div>
              <div class="Container-Card-Annexes">

                <div *ngIf="FileAuxUpdFIN_Annexes.length === 0">No hay anexos cargados aún.</div>

                <div *ngFor="let Annexe of FileAuxUpdFIN_Annexes" class="Card-Annexes">

                  <div class="Container-File">
                    <ng-container *ngFor="let icon of Icons_Image">
                      <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()" [class.Is-Disabled-Img]="NameFileFINUpdate.invalid">
                        <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                      </div>
                    </ng-container>
                    <div class="Name-Annexe">
                      {{CutNameFile(Annexe.FileName,35)}}
                    </div>
                  </div>

                  <div class="Container-Buttons-Annexe">
                    <button type="button" [disabled]="NameFileFINUpdate.invalid"
                      *ngIf="Annexe.UpdateAnnexe.FileName!==''" class="button-square">
                      <i class="fa-regular fa-paste"></i>
                    </button>
                    <button type="button" [disabled]="NameFileFINUpdate.invalid" *ngIf="Annexe.ID!==0"
                      (click)="Annexe_Update(Annexe)" class="Update-Annexe button-square">
                      <i class="fa-solid fa-upload"></i>
                    </button>
                    <button type="button" [disabled]="NameFileFINUpdate.invalid"
                      (click)="Delete_Annexe_Upd(Annexe.FileName)" class="Delete-Annexe button-square">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>


                </div>

              </div>

            </div>

          </div>

          <div class="Container-Progress" id="Content-Progress-Update">
            <div class="ProgressBar" id="Progress-Bar-Update"></div>
          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" id="BtnSavedFIN-Update">
              <i class="icon-send material-icons" id="Send-Icon-Update">{{GetSubmitButtonIconUpdate()}}</i>
              <i class="icon-check material-icons" id="Check-Icon-Update">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn-Update">{{GetSubmitButtonTextUpdate()}}</span>
            </button>
            <button type="button" id="Btn-Close-Upd-Bottom" (click)="ToggleModalUpdateFIN(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>

        </div>
      </form>
    </div>
  </div>

  <div class="Sweet-Alert" id="Sweet_Alert_Update">
    <div class="Sweet-Alert--Icon">
      <div class="swal2-icon swal2-question swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">?</div>
      </div>
    </div>
    <div class="Sweet-Alert--Title">
      ¿Los datos son correctos?
    </div>
    <div class="Sweet-Alert--Text">
      Si todo esta bien, presiona el botón para continuar
    </div>
    <div class="Sweet-Alert--Container-Button">
      <button (click)="Sweet_Alert_Send_New_FIN_Update()" class="Sweet-Alert--Container-Button--Button btn-icon-text">
        <i class="fa-solid fa-check-double"></i> <span>Sí, son correctos</span>
      </button>
      <button (click)="Toggle_Modal_Sweet_Alert_SendFIN_Update(false)"
        class="Sweet-Alert--Container-Button--Button Cancel btn-icon-text">
        <span>Cancel</span>
      </button>
    </div>
  </div>
</section>

<!---===================== MODAL FOR UPDATE ANNEXES FOR APROVED FIN =====================--->
<section class="Modal-Global" id="Modal-Update-Annexes-Approved">
  <div class="wrapper">
    <div class="Pro-popup-Update-Annexe1 popup">
      <div class="Pro-inside-Update-Annexe1 popup-inside">
        <div class="Pro-backgrounds-Update-Annexe1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form (ngSubmit)="Validate_Update_Annexes_Approved()">
        <div class="Pro-content-Update-Annexe1 content">
          <button type="button" id="Btn-Close-Update-Annexes-Approved-Top" class="Btn-Close"
            (click)="ToggleModal_Update_Annexes_Approved(false)"><i class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Actualización de anexos</h2>
            <h4>Esta actualizando los anexos del Proceso {{this.FFIN_Select_CM.Name}}</h4>
          </div>

          <div class="Content-body">

            <div class="Content-grid-2">
              <div class="Text-icon">
                Anexos
              </div>
              <div class="Container-input InputFile">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivos</div><input #UpdFileAnnexe type="file" name=""
                    (change)="Add_Document_Annexe_Upd($event)">
                </div>
              </div>
            </div>

            <div class="Content-grid-2 Container-Annexes">
              <div class="Not-Annexes">
                <div class="Img-Not ">
                  <img src="./assets/Global/Ilustrations/Not-Annexes.png" alt="">
                </div>
              </div>
              <div class="Container-Card-Annexes">

                <div *ngIf="FileAuxUpdFIN_Annexes.length === 0">No hay anexos cargados aún.</div>

                <ng-container *ngFor="let Annexe of FileAuxUpdFIN_Annexes">

                  <div *ngIf="Annexe.Status!==5" class="Card-Annexes">

                    <div class="Container-File">
                      <ng-container *ngFor="let icon of Icons_Image">
                        <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                          <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                        </div>
                      </ng-container>
                      <div class="Name-Annexe">
                        {{CutNameFile(Annexe.FileName,35)}}
                      </div>
                    </div>

                    <div class="Container-Buttons-Annexe">
                      <button type="button" *ngIf="Annexe.UpdateAnnexe.FileName!==''" class="button-square">
                        <i class="fa-regular fa-paste"></i>
                      </button>
                      <button type="button" *ngIf="Annexe.ID!==0" (click)="Annexe_Update(Annexe)"
                        class="Update-Annexe button-square">
                        <i class="fa-solid fa-upload"></i>
                      </button>
                      <button type="button" (click)="Delete_Annexe_Update_Modal(Annexe.FileName)"
                        class="Delete-Annexe button-square">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>




                </ng-container>

              </div>

            </div>

          </div>

          <div class="Container-Progress" id="Content-Progress-Update-Annexes-Approved">
            <div class="ProgressBar" id="Progress-Bar-Update-Annexes-Approved"></div>
          </div>
          <div class="Content-Bottom Update-Annexes">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" id="BtnSavedFIN-Update-Annexes-Approved">
              <i class="icon-send material-icons" id="Send-Icon-Update-Annexes-Approved">send</i>
              <i class="icon-check material-icons" id="Check-Icon-Update-Annexes-Approved">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn-Update-Annexes-Approved">Actualizar anexos</span>
            </button>
            <button type="button" id="Btn-Close-Update-Annexes-Approved-Bot"
              (click)="ToggleModal_Update_Annexes_Approved(false)" class="Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>

        </div>
      </form>

    </div>
  </div>
</section>

<!---===================== MODAL FOR UPDATE ANNEXE =====================--->
<section class="Modal-Global" id="Modal_Update_Annexe">

  <div class="wrapper">
    <div class="Popup-Add-annexe popup">
      <div class="Inside-Add-annexe popup-inside">
        <div class="Background-Add-annexe backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Content-Add-annexe content">
        <button (click)="Toogle_Modal_Update_Annexe(false)" type="button" id="Btn-Close-Update-Top" class="Btn-Close"><i
            class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Actualizar Anexo</h2>
          <h4>Seleccione un archivo para actualizar</h4>
        </div>

        <div class="Content-body">

          <div class="Container-input-annexe">

            <div class="IputFileleft">
              <i class="fa-solid fa-plus"></i>
              <div class="Text-input">Cargar Archivo</div><input #UpdFile_Update_Annexe
                (change)="Add_Annexe_Update($event)" type="file" name="">
            </div>

            <div *ngIf="FileAuxUpdFIN_Annexe_Update.UpdateAnnexe.FileName!==''"
              class="Container-Card-Annexes Card-Update-Annexe">

              <div class="Card-Annexes">

                <div class="Container-File">
                  <ng-container *ngFor="let icon of Icons_Image">
                    <div *ngIf="FileAuxUpdFIN_Annexe_Update.UpdateAnnexe.Extension.toUpperCase() === icon.Extension.toUpperCase()">
                      <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                    </div>
                  </ng-container>
                  <div class="Name-Annexe">
                    {{CutNameFile(FileAuxUpdFIN_Annexe_Update.UpdateAnnexe.FileName,35)}}
                  </div>
                </div>

                <div class="Container-Buttons-Annexe">
                  <button (click)="Delete_Update_Annexe()" type="button" class="Delete-Annexe button-square">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>

              </div>

            </div>

          </div>
        </div>

        <div class="Content-Bottom Modal-Annexe">
          <button (click)="Toogle_Modal_Update_Annexe(false)" type="button" class="Btn-OK">
            <span>OK</span>
          </button>
        </div>

      </div>

    </div>

  </div>

</section>



<!---===================== MODAL FOR NOTIFICATION GROUPS FIN UPDATE =====================--->
<section class="Modal-Global" id="ModalNotificationFINUpdate">
  <div class="wrapper">
    <div class="Pro-popupNotFIN1 popup">
      <div class="Pro-insideNotFIN1 popup-inside">
        <div class="Pro-backgroundsNotFIN1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentNotFIN1 content">
        <div class="Btn-Close"></div>
        <div class="Content-Top">
          <h2>Notificar a grupos</h2>
        </div>

        <div class="Container-Body-Notification Content-body">


          <ng-container *ngIf="Group_Notification.length>0 else Not_Groups">
            <div *ngFor="let group of Group_Notification;let i = index" class="Container-Grid-Local Content-grid-2">
              <div class="Container-input Input-CheckBox">
                <input type="checkbox" id="CheckBoxUpdate{{i}}" class="ui-checkbox">
              </div>
              <div class="Text-icon">
                {{group.Name}}
              </div>
            </div>
          </ng-container>

          <ng-template #Not_Groups>
            <div class="Not-Groups">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Mail_Groups.png" alt="">
              </div>
              <div class="Text-Not-Groups">
                No existen grupos de notificación para cargas de Procesos.
              </div>
            </div>
          </ng-template>

        </div>
        <div class="Content-Bottom">
          <div (click)="SavedUpdateFIN()" class="Btn-LSave-Form Btn-Save-Modal">
            <i class="Icon-Two fa-regular fa-bell"></i>
            <span class="Btn-Save-Modal-text" id="Text-Btn">Guardar</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
